/*------------------------------------------------
// File Name:PDM_MA_PackItem.js
// File Description:PDM_MA_PackItem store方法
// Author:zxl
// Create Time:2023/06/06 15:39:47
//------------------------------------------------*/

import {
    GetPDM_MA_PackItemList,
    GetPDM_MA_PackItemListByPage,
    GetPDM_MA_PackItemEntity,
    CreatePDM_MA_PackItemEntity,
    UpdatePDM_MA_PackItemEntity,
    DeletePDM_MA_PackItemEntity,
} from '@/api/pdm/ma/maPackItem'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmMaPackItem = {
    namespaced: true,
    state: {
        PdmMaPackItemList: [],
        PdmMaPackItemListLoading: false,
        PdmMaPackItemEntity: null,
        PdmMaPackItemShowDlg: false,
    },
    mutations: {
        setPdmMaPackItemList(state, dataList) {
            state.PdmMaPackItemList = [...dataList]
        },
        setPdmMaPackItemListLoading(state, visible) {
            state.PdmMaPackItemListLoading = visible
        },
        setPdmMaPackItemShowDlg(state, visible) {
            state.PdmMaPackItemShowDlg = visible
        },
        setPdmMaPackItemEntity(state, entity) {
            state.PdmMaPackItemEntity = entity
        },
    },
    actions: {
        //创建套餐项目对象
        actCreatePdmMaPackItem({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_MA_PackItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPackItemEntity', res.Data)
                        commit('setPdmMaPackItemShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载套餐项目对象
        actGetPdmMaPackItemEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPackItemListLoading', true)
                GetPDM_MA_PackItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPackItemEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPackItemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载套餐项目列表
        actGetPdmMaPackItemList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPackItemListLoading', true)
                GetPDM_MA_PackItemList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPackItemList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPackItemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载套餐项目列表
        actGetPdmMaPackItemListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPackItemListLoading', true)
                GetPDM_MA_PackItemListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPackItemList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPackItemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存套餐项目信息
        actUpdatePdmMaPackItem({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_MA_PackItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPackItemShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_PackItem
        actEditPdmMaPackItemData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmMaPackItemID : entity.PdmMaPackItemID
                }
                GetPDM_MA_PackItemEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmMaPackItemEntity', res.Data)
                        commit('setPdmMaPackItemShowDlg', true)
                        // msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_PackItem ,传对象过来
        actEditPdmMaPackItem({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmMaPackItemEntity', entity)
                commit('setPdmMaPackItemShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_MA_PackItem
        actDeletePdmMaPackItem({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前套餐项目？").onOk(() => {
                    DeletePDM_MA_PackItemEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmMaPackItemShowDlg', false)
                           
                            msg.success("删除套餐项目成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除套餐项目失败，原因:" + res.Message)
                            //msg.success("删除套餐项目失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


